/* Pencil Lane — storefront behaviour. No framework; progressive enhancement only. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  // en-US grouping: $1,052.47, matching Liquid's money filter (it printed $1052.47 beside it)
  const money = c => `$${(c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  /* ---- cart drawer -------------------------------------------------------- */
  const COMPARE = {};
  function compareFor(variantId) {
    return Number(COMPARE[variantId] || 0);
  }

  const drawer = { el: null, scrim: null };

  function openDrawer() {
    drawer.el?.classList.add('is-open');
    drawer.scrim?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    drawer.el?.querySelector('[data-close]')?.focus();
  }
  function closeDrawer() {
    drawer.el?.classList.remove('is-open');
    drawer.scrim?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async function getCart() {
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async function changeLine(key, quantity) {
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    return res.json();
  }

  async function addItems(items) {
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) throw new Error((await res.json()).description || 'Could not add to cart');
    return res.json();
  }

  function renderUnlock(cart) {
    const box = $('[data-unlock]');
    if (!box) return;
    const tiers = JSON.parse(box.dataset.unlock || '[]');   // [{cents, label}]
    if (!tiers.length) return;
    // The spend tiers apply to SINGLE PACKS only (owner 2026-10-01: bundles never drop below their
    // price), so the bar counts only those lines -- a $97 bundle must not show "20% unlocked".
    const types = JSON.parse(box.dataset.unlockTypes || 'null');
    const subtotal = types
      ? cart.items.filter(i => types.includes(i.product_type)).reduce((s, i) => s + i.original_line_price, 0)
      : (cart.items_subtotal_price ?? cart.total_price);
    const max = tiers[tiers.length - 1].cents;
    const pct = Math.max(0, Math.min(100, (subtotal / max) * 100));
    $('[data-unlock-fill]', box).style.width = `${pct}%`;
    const hit = tiers.filter(t => subtotal >= t.cents).length;
    $$('[data-unlock-pt]', box).forEach((pt, i) => pt.classList.toggle('is-hit', i < hit));
    const title = $('[data-unlock-title]', box);
    const next = tiers.find(t => subtotal < t.cents);
    title.textContent = next
      ? `Add ${money(next.cents - subtotal)} more to get ${next.label}`
      : `Nice — ${tiers[tiers.length - 1].label} is applied at checkout.`;
  }

  // Each line's real compare-at price comes from /products/<handle>.js (cart.js does not carry it).
  const fetchedHandles = new Set();
  async function ensureCompare(cart) {
    const need = [...new Set(cart.items.filter(i => !(i.variant_id in COMPARE) && !fetchedHandles.has(i.handle)).map(i => i.handle))];
    if (!need.length) return false;
    await Promise.all(need.map(async h => {
      fetchedHandles.add(h);
      try {
        const p = await (await fetch(`/products/${h}.js`)).json();
        (p.variants || []).forEach(v => { COMPARE[v.id] = Number(v.compare_at_price || 0); });
      } catch (e) { /* no compare shown for this line */ }
    }));
    return true;
  }

  function lineHTML(item) {
    const cmp = compareFor(item.variant_id);
    const free = item.final_price === 0;
    const img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_140x$1$2') : '';
    const saved = item.original_line_price - item.final_line_price;
    return `<div class="litem ${free ? 'litem--free' : ''}">
      ${img ? `<img src="${img}" alt="" loading="lazy">` : ''}
      <div style="flex:1;min-width:0">
        <a class="litem__t" href="${item.url}">${item.product_title}</a>
        ${item.sku ? `<div class="litem__sku">${item.sku}</div>`
                   : (item.product_type ? `<div class="litem__meta">${item.product_type}</div>` : '')}
        <div class="litem__row">
          <div class="litem__price">
            ${free ? `${cmp > 0 ? `<s>${money(cmp)}</s>` : ''}<span class="litem__free">FREE</span>`
                   : `${cmp > item.final_price ? `<s>${money(cmp)}</s>` : ''}<b>${money(item.final_price)}</b>`}
          </div>
          <div class="litem__ctl">
            ${free ? '' : `<div class="qty">
              <button type="button" data-qty="${item.key}" data-to="${item.quantity - 1}" aria-label="Decrease">&minus;</button>
              <input type="number" value="${item.quantity}" min="0" data-qty-input="${item.key}" aria-label="Quantity">
              <button type="button" data-qty="${item.key}" data-to="${item.quantity + 1}" aria-label="Increase">+</button>
            </div>`}
            <button type="button" class="litem__del" data-qty="${item.key}" data-to="0"
                    aria-label="Remove ${item.product_title}">
              <svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"
                   stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M4.5 7h15M9.5 7V4.8h5V7M6.5 7l.9 12.2A1.9 1.9 0 0 0 9.3 21h5.4a1.9 1.9 0 0 0 1.9-1.8L17.5 7"/>
              </svg>
            </button>
          </div>
        </div>
      </div></div>`;
  }

  /* ---- cross-sell inside the drawer -------------------------------------- */
  // Upsell ladder: for every item in the cart, its next rungs up (family bundle -> grade MEGA -> Buy 3
  // Get 1 pack -> subject endless), in cart order, deduped, never something already in the cart and never
  // something a cart item already contains (upsell.in: cart handle -> indexes into upsell.tl).
  let upsell = null;
  async function loadUpsell() {
    if (upsell) return upsell;
    const src = $('#upsell-src')?.dataset.src;
    if (!src) return (upsell = { map: {}, t: {} });
    try { upsell = await (await fetch(src)).json(); } catch { upsell = { map: {}, t: {} }; }
    return upsell;
  }
  function xsellHTML(cart) {
    if (!upsell) return '';
    const inCart = new Set(cart.items.map(i => i.variant_id));
    const handles = new Set(cart.items.map(i => i.handle));
    const owned = new Set();
    for (const h of handles) for (const n of ((upsell.in || {})[h] || [])) owned.add((upsell.tl || [])[n]);
    const seen = new Set();
    const offers = [];
    for (const item of cart.items) {
      for (const h of (upsell.map[item.handle] || [])) {
        const x = upsell.t[h];
        if (!x || seen.has(h) || handles.has(h) || owned.has(h) || inCart.has(x.id)) continue;
        seen.add(h); offers.push(x);
      }
    }
    offers.splice(6);
    if (!offers.length) return '';
    const cards = offers.map(x => `<div class="xcard">
        <img src="${x.image}" alt="" loading="lazy">
        <a class="xcard__t" href="${x.url}">${x.title}</a>
        <span class="xcard__m">${x.meta}${x.compare > x.price ? ` · was ${money(x.compare)}` : ''}</span>
        <button class="xcard__add" type="button" data-xadd="${x.id}">Add · ${money(x.price)}</button>
      </div>`).join('');
    return `<div class="xsell">
      <div class="xsell__hd"><h3>Go bigger and save</h3>
        <div class="arrows" data-rail-controls>
          <button class="arrow" type="button" data-rail-prev aria-label="Previous">
            <svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
              stroke-linecap="round" stroke-linejoin="round"><path d="M19.5 12h-15m0 0 5.5-5.5M4.5 12 10 17.5"/></svg></button>
          <button class="arrow" type="button" data-rail-next aria-label="Next">
            <svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
              stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 12h15m0 0-5.5-5.5M19.5 12 14 17.5"/></svg></button>
        </div></div>
      <div class="rail" data-rail>${cards}</div></div>`;
  }

  function reviewsHTML() {
    const node = $('#cart-reviews');
    if (!node) return '';
    let list = [];
    try { list = JSON.parse(node.textContent); } catch { return ''; }
    if (!list.length) return '';                    // no real reviews yet: render nothing
    const star = '<svg class="ico" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">'
      + '<path d="m12 3.6 2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L3.5 9.8l5.9-.9z"/></svg>';
    const cards = list.map(r => `<div class="rcard">
        <div class="rcard__stars">${star.repeat(Math.max(1, Math.min(5, r.stars || 5)))}</div>
        <p>“${r.text}”</p>
        <div class="rcard__who"><span class="rcard__av">${(r.who || '?').slice(0, 1)}</span>${r.who || ''}</div>
      </div>`).join('');
    return `<div class="creas">
      <div class="creas__hd"><span>What teachers say</span>
        <div class="arrows" data-rail-controls>
          <button class="arrow" type="button" data-rail-prev aria-label="Previous">
            <svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
              stroke-linecap="round" stroke-linejoin="round"><path d="M19.5 12h-15m0 0 5.5-5.5M4.5 12 10 17.5"/></svg></button>
          <button class="arrow" type="button" data-rail-next aria-label="Next">
            <svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
              stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 12h15m0 0-5.5-5.5M19.5 12 14 17.5"/></svg></button>
        </div></div>
      <div class="rail" data-rail>${cards}</div>
      ${list.some(r => r.sample) ? '<p class="rev__sample">⚠ Sample layout — placeholder text, not customer reviews.</p>' : ''}
      </div>`;
  }

  function renderCart(cart) {
    renderCartNow(cart);
    ensureCompare(cart).then(changed => { if (changed) renderCartNow(cart); });
  }

  function renderCartNow(cart) {
    $$('[data-cart-count]').forEach(n => {
      n.textContent = cart.item_count;
      n.hidden = cart.item_count === 0;
    });
    const body = $('[data-cart-body]');
    const foot = $('[data-cart-foot]');
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = `<div class="drawer__empty"><p>Your cart is empty.</p>
        <a class="btn btn--brand" href="/collections/all">Browse printables</a></div>`;
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    body.innerHTML = `<div data-unlock-mount></div>${giftNote(cart)}${cart.items.map(lineHTML).join('')}`
      + `${xsellHTML(cart)}${reviewsHTML()}`;
    const tpl = $('#unlock-template');
    if (tpl) {
      $('[data-unlock-mount]', body).innerHTML = tpl.innerHTML;
      renderUnlock(cart);
    }
    const value = cart.items.reduce((s, i) => s + Math.max(compareFor(i.variant_id) * i.quantity, i.original_line_price), 0);
    const saved = Math.max(0, value - cart.total_price);
    const banner = $('[data-cart-savings]');
    if (banner) {
      banner.hidden = saved <= 0;
      banner.innerHTML = saved > 0
        ? `<span>Total value <s>${money(value)}</s></span><span>You save <b>${money(saved)}</b> (${Math.round(saved / value * 100)}%)</span>`
        : '';
    }
    $('[data-cart-total]').textContent = money(cart.total_price);
    const countEl = $('[data-cart-items]');
    if (countEl) countEl.textContent = `${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`;
    const savedEl = $('[data-cart-saved]');
    if (savedEl) {
      savedEl.hidden = saved <= 0;
      savedEl.textContent = saved > 0 ? `You save ${money(saved)}` : '';
    }
    initRails();
    $('[data-checkout]')?.replaceChildren(document.createTextNode(`Checkout · ${money(cart.total_price)}`));
  }


  /* ---- free gift tiers (head-to-head fix 15): spend $30 -> 2 free packs, $45 -> 2 more.
     Shopify's automatic "Free gift" discounts make them $0; this adds/removes the gift lines so the
     shopper doesn't have to. Gift lines themselves never count toward the threshold. ---- */
  let giftBusy = false;
  async function syncGifts(cart) {
    const node = $('#gift-tiers');
    if (!node || giftBusy) return false;
    let tiers = []; try { tiers = JSON.parse(node.textContent); } catch { return false; }
    const giftIds = new Set(tiers.flatMap(t => t.items));
    const spend = cart.items.filter(i => !giftIds.has(i.variant_id)).reduce((s, i) => s + i.original_line_price, 0);
    const want = new Set(tiers.filter(t => spend >= t.cents).flatMap(t => t.items));
    // only lines this script added (marked _gift) are ever removed -- a pack the shopper chose stays
    const have = new Map(cart.items.filter(i => giftIds.has(i.variant_id) && (i.properties || {})._gift).map(i => [i.variant_id, i]));
    const inCartIds = new Set(cart.items.map(i => i.variant_id));
    const add = [...want].filter(id => !have.has(id) && !inCartIds.has(id));
    const drop = [...have.keys()].filter(id => !want.has(id));
    if (!add.length && !drop.length) return false;
    giftBusy = true;
    try {
      if (add.length) await addItems(add.map(id => ({ id, quantity: 1, properties: { _gift: 'yes' } })));
      for (const id of drop) await changeLine(have.get(id).key, 0);
    } catch (e) { /* a gift failing to add must never block the cart */ }
    giftBusy = false;
    return true;
  }
  function giftNote(cart) {
    const node = $('#gift-tiers'); if (!node) return '';
    let tiers = []; try { tiers = JSON.parse(node.textContent); } catch { return ''; }
    const giftIds = new Set(tiers.flatMap(t => t.items));
    const spend = cart.items.filter(i => !giftIds.has(i.variant_id)).reduce((s, i) => s + i.original_line_price, 0);
    const next = tiers.find(t => spend < t.cents);
    const got = tiers.filter(t => spend >= t.cents).length;
    const msg = next ? `Add ${money(next.cents - spend)} more to get ${next.label}` : 'Both free gifts are in your cart';
    return `<div class="giftnote">${got ? '🎁 ' : ''}${msg}</div>`;
  }

  async function refresh(open = false) {
    let [cart] = await Promise.all([getCart(), loadUpsell()]);
    if (await syncGifts(cart)) cart = await getCart();
    renderCart(cart);
    if (open) openDrawer();
  }

  /* ---- delegated events --------------------------------------------------- */
  document.addEventListener('click', async e => {
    const openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); refresh(true); return; }
    if (e.target.closest('[data-close]') || e.target.closest('.scrim')) { closeDrawer(); return; }

    const qtyBtn = e.target.closest('[data-qty]');
    if (qtyBtn) {
      qtyBtn.disabled = true;
      renderCart(await changeLine(qtyBtn.dataset.qty, Number(qtyBtn.dataset.to)));
      return;
    }
    const xadd = e.target.closest('[data-xadd]');
    if (xadd) {
      xadd.disabled = true;
      const previous = xadd.textContent;
      xadd.textContent = 'Adding…';
      try { await addItems([{ id: Number(xadd.dataset.xadd), quantity: 1 }]); await refresh(false); }
      catch { xadd.disabled = false; xadd.textContent = previous; }
      return;
    }

    // dropdown buttons: tap/click toggles (hover handles desktop pointers); clicking elsewhere closes
    const dd = e.target.closest('.navdd__btn');
    $$('.navdd.is-open').forEach(n => { if (!dd || n !== dd.parentElement) { n.classList.remove('is-open'); n.firstElementChild.setAttribute('aria-expanded', 'false'); } });
    if (dd) { const open = dd.parentElement.classList.toggle('is-open'); dd.setAttribute('aria-expanded', String(open)); return; }
    const nav = e.target.closest('[data-mnav-toggle]');
    if (nav) { $('.mnav')?.classList.toggle('is-open'); return; }

    const thumb = e.target.closest('[data-thumb]');
    if (thumb) { showImage([...$$('[data-thumb]')].indexOf(thumb)); return; }
    if (e.target.closest('[data-gal-prev]')) { stepImage(-1); return; }
    if (e.target.closest('[data-gal-next]')) { stepImage(1); return; }
    const sp = e.target.closest('[data-strip-prev],[data-strip-next]');
    if (sp) {
      const strip = sp.parentElement.querySelector('[data-strip]');
      const dir = sp.matches('[data-strip-next]') ? 1 : -1;
      strip?.scrollBy({ left: dir * strip.clientWidth * 0.8, behavior: 'smooth' });
    }
  });

  /* ---- add-on ticked: the add-to-cart button shows the real total ---------- */
  document.addEventListener('change', e => {
    const bumpBox = e.target.closest('[data-bump]');
    if (!bumpBox) return;
    const form = bumpBox.closest('[data-atc-form]');
    const out = form?.querySelector('[data-atc-price]');
    if (!out || !form.dataset.base) return;
    const extra = $$('[data-bump]:checked', form).reduce((s, b) => s + Number(b.dataset.price || 0), 0);
    out.textContent = money(Number(form.dataset.base) + extra);
  });

  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  /* ---- add to cart (product form + bundle builder) ------------------------ */
  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-atc-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const label = btn?.innerHTML;
    if (btn) { btn.disabled = true; if (!form.hasAttribute('data-quiet')) btn.textContent = 'Adding…'; }
    const items = [{ id: Number(form.querySelector('[name="id"]').value),
                     quantity: Number(form.querySelector('[name="quantity"]')?.value || 1) }];
    $$('[data-bump]:checked', form).forEach(b => items.push({ id: Number(b.value), quantity: 1 }));
    try {
      await addItems(items);
      const quiet = form.hasAttribute('data-quiet');
      await refresh(!quiet);
      if (quiet && btn) {
        btn.classList.add('is-added');
        btn.innerHTML = '<svg class="ico" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor"'
          + ' stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.6 4.5L19 7.5"/></svg>';
        setTimeout(() => { btn.classList.remove('is-added'); btn.innerHTML = label; }, 1600);
        return;
      }
    } catch (err) {
      const note = form.querySelector('[data-atc-error]');
      if (note) { note.textContent = err.message; note.hidden = false; }
    } finally {
      if (btn) { btn.disabled = false; if (!btn.classList.contains('is-added')) btn.innerHTML = label; }
    }
  });

  /* ---- product gallery ---------------------------------------------------- */
  function showImage(index) {
    const thumbs = $$('[data-thumb]');
    if (!thumbs.length) return;
    const i = (index + thumbs.length) % thumbs.length;
    const thumb = thumbs[i];
    const main = $('[data-gallery-main]');
    if (main) { main.src = thumb.dataset.full; main.alt = thumb.dataset.alt || ''; }
    thumbs.forEach(t => t.setAttribute('aria-selected', String(t === thumb)));
    const count = $('[data-gal-count]');
    if (count) count.textContent = `${i + 1} / ${thumbs.length}`;
    // keep the active thumbnail visible in a scrolling strip, without scrolling the page
    const strip = thumb.closest('[data-strip]');
    if (strip) {
      const l = thumb.offsetLeft - strip.offsetLeft, r = l + thumb.offsetWidth;
      if (l < strip.scrollLeft) strip.scrollTo({ left: l, behavior: 'smooth' });
      else if (r > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: r - strip.clientWidth, behavior: 'smooth' });
    }
  }

  function stepImage(delta) {
    const thumbs = $$('[data-thumb]');
    const current = thumbs.findIndex(t => t.getAttribute('aria-selected') === 'true');
    showImage((current < 0 ? 0 : current) + delta);
  }

  /* ---- sticky mobile buy bar --------------------------------------------- */
  function initStickyBuy() {
    const bar = $('[data-stickybuy]');
    const mainForm = $('.buy [data-atc-form]');
    if (!bar || !mainForm || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([entry]) => {
      bar.classList.toggle('is-on', !entry.isIntersecting);
    }, { rootMargin: '-10px 0px 0px 0px' }).observe(mainForm);
  }

  /* ---- review slider: arrows, dots, autoplay ----------------------------- */
  function initReviews() {
    const track = $('[data-rev-track]');
    if (!track) return;
    const dots = $('[data-rev-dots]');
    const cards = [...track.children];
    if (!cards.length) return;

    const perView = () => Math.max(1, Math.round(track.clientWidth / cards[0].getBoundingClientRect().width));
    const pages = () => Math.max(1, Math.ceil(cards.length / perView()));
    const current = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));

    function paint() {
      const n = pages(), i = Math.min(current(), n - 1);
      if (dots && dots.childElementCount !== n) {
        dots.innerHTML = Array.from({ length: n }, (_, k) =>
          `<button class="rev__dot" type="button" role="tab" data-rev-dot="${k}" aria-label="Page ${k + 1}"></button>`
        ).join('');
      }
      $$('[data-rev-dot]', dots || document).forEach((d, k) =>
        d.setAttribute('aria-selected', String(k === i)));
      const prev = $('[data-rev-prev]'), next = $('[data-rev-next]');
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }

    const go = dir => track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
    $('[data-rev-prev]')?.addEventListener('click', () => { go(-1); stop(); });
    $('[data-rev-next]')?.addEventListener('click', () => { go(1); stop(); });
    dots?.addEventListener('click', e => {
      const d = e.target.closest('[data-rev-dot]');
      if (!d) return;
      track.scrollTo({ left: Number(d.dataset.revDot) * track.clientWidth, behavior: 'smooth' });
      stop();
    });
    track.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint, { passive: true });

    let timer = setInterval(() => {
      if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) track.scrollTo({ left: 0, behavior: 'smooth' });
      else go(1);
    }, 6000);
    function stop() { clearInterval(timer); timer = null; }
    track.addEventListener('pointerdown', stop, { once: true });

    paint();
  }

  /* ---- horizontal rails --------------------------------------------------- */
  function railStep(rail) {
    const first = rail.querySelector(':scope > *');
    const gap = parseFloat(getComputedStyle(rail).columnGap || '16') || 16;
    return first ? first.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
  }

  function railScope(rail) {
    // the controls live in a sibling header; walk up until we find the element holding both,
    // otherwise a rail inside the cart drawer binds to some other section's buttons
    let el = rail.parentElement;
    while (el && !el.querySelector('[data-rail-prev]')) el = el.parentElement;
    return el || document;
  }

  function syncRail(rail) {
    const wrap = railScope(rail);
    const prev = wrap.querySelector('[data-rail-prev]');
    const next = wrap.querySelector('[data-rail-next]');
    if (!prev || !next) return;
    const max = rail.scrollWidth - rail.clientWidth - 2;
    prev.disabled = rail.scrollLeft <= 2;
    next.disabled = rail.scrollLeft >= max;
    const overflows = rail.scrollWidth > rail.clientWidth + 4;
    prev.closest('[data-rail-controls]').hidden = !overflows;
  }

  function initRails() {
    $$('[data-rail]').forEach(rail => {
      if (rail.dataset.railBound === '1') { syncRail(rail); return; }   // cart re-renders; bind once
      rail.dataset.railBound = '1';
      syncRail(rail);
      rail.addEventListener('scroll', () => syncRail(rail), { passive: true });
      const wrap = railScope(rail);
      wrap.querySelector('[data-rail-prev]')?.addEventListener('click', e => {
        e.preventDefault(); rail.scrollBy({ left: -railStep(rail), behavior: 'smooth' });
      });
      wrap.querySelector('[data-rail-next]')?.addEventListener('click', e => {
        e.preventDefault(); rail.scrollBy({ left: railStep(rail), behavior: 'smooth' });
      });
    });
    window.addEventListener('resize', () => $$('[data-rail]').forEach(syncRail), { passive: true });
  }

  /* ---- bundle builder total ---------------------------------------------- */
  function syncBuilder() {
    const box = $('[data-builder]');
    if (!box) return;
    const all = $$('[data-builder-item]', box);
    const picked = all.filter(i => i.checked);
    const total = picked.reduce((s, i) => s + Number(i.dataset.price), 0);
    const was = picked.reduce((s, i) => s + Number(i.dataset.compare || i.dataset.price), 0);

    // data-unit lets a bundle page say "bundle" where the pack builder says "pack"
    const unit = box.dataset.unit || 'pack';
    const units = n => `${n} ${n === 1 ? unit : unit + 's'}`;
    const heading = $('[data-bb-heading]', box);
    if (heading) {
      heading.textContent = picked.length
        ? `Your selection: ${units(picked.length)} for ${money(total)}`
        : 'Your selection';
    }
    const totWas = $('[data-bb-totwas]', box);
    if (totWas) totWas.textContent = was > total ? money(was) : '';
    const compare = $('[data-bb-compare]', box);
    if (compare) compare.innerHTML = was > total ? `<s>${money(was)}</s>` : '';
    const saveText = $('[data-bb-savetext]', box);
    if (saveText) {
      const pct = was > total ? Math.round(((was - total) / was) * 100) : 0;
      saveText.textContent = pct ? `Save ${money(was - total)} (${pct}% off)` : '';
    }
    const thumbs = $('[data-bb-thumbs]', box);
    if (thumbs) {
      thumbs.innerHTML = all.map((i, idx) =>
        `${idx ? '<span class="bb__plus">+</span>' : ''}` +
        `<button type="button" class="bb__thumb ${i.checked ? 'is-on' : 'is-off'}" data-bb-toggle="${idx}"` +
        ` aria-pressed="${i.checked}" aria-label="${i.dataset.title || 'pack'}">` +
        `<img src="${i.dataset.img}" alt=""></button>`
      ).join('');
    }
    $('[data-builder-total]', box).textContent = money(total);
    const saveEl = $('[data-builder-save]', box);
    if (saveEl) {
      saveEl.hidden = was <= total;
      const span = saveEl.querySelector('span');
      const pct = was > total ? Math.round(((was - total) / was) * 100) : 0;
      if (span) span.textContent = `You save ${money(was - total)}${box.dataset.unit && pct ? ` (${pct}% off)` : ''}`;
    }
    const btn = $('[data-builder-add]', box);
    if (btn) {
      btn.disabled = !picked.length;
      btn.textContent = picked.length
        ? (box.dataset.unit ? `Add ${units(picked.length)} to cart — ${money(total)}` : `Add ${picked.length} to cart · ${money(total)}`)
        : `Choose at least one ${unit}`;
    }
  }

  /* ---- demo videos: play on tap, pause the others ------------------------- */
  function initVideos() {
    $$('[data-video]').forEach(card => card.addEventListener('click', () => {
      const vid = card.querySelector('video');
      if (!vid) return;
      $$('[data-video]').forEach(other => {
        if (other !== card) {
          other.classList.remove('is-playing');
          other.querySelector('video')?.pause();
        }
      });
      if (vid.paused) { vid.play(); card.classList.add('is-playing'); }
      else { vid.pause(); card.classList.remove('is-playing'); }
    }));
  }
  document.addEventListener('click', e => {
    const th = e.target.closest('[data-bb-toggle]');
    if (!th) return;
    const box = $$('[data-builder-item]')[Number(th.dataset.bbToggle)];
    if (box) { box.checked = !box.checked; syncBuilder(); }
  });

  document.addEventListener('change', e => {
    if (e.target.matches('[data-builder-item]')) syncBuilder();
    if (e.target.matches('[data-qty-input]')) changeLine(e.target.dataset.qtyInput, Number(e.target.value)).then(renderCart);
  });
  document.addEventListener('click', async e => {
    const add = e.target.closest('[data-builder-add]');
    if (!add) return;
    const items = $$('[data-builder-item]:checked').map(i => ({ id: Number(i.value), quantity: 1 }));
    if (!items.length) return;
    add.disabled = true;
    try {
      await addItems(items);
      // TOGETHER15: only when every item in the bought-together set was added (the section sets
      // data-together only when the page product + at least one FBT item are single packs / decks)
      const box = add.closest('[data-builder]');
      const all = box ? $$('[data-builder-item]', box) : [];
      if (box?.dataset.together && all.length >= 2 && all.every(i => i.checked)) {
        try { await fetch(`/discount/${box.dataset.together}`, { credentials: 'same-origin' }); } catch {}
      }
      await refresh(true);
    } finally { add.disabled = false; syncBuilder(); }
  });

  document.addEventListener('DOMContentLoaded', () => {
    drawer.el = $('.drawer');
    drawer.scrim = $('.scrim');
    syncBuilder();
    initRails();
    initStickyBuy();
    initVideos();
    initReviews();
    refresh(false);
  });
})();
